export default __webpack_public_path__ + "static/media/alexander-hipp-iEEBWgY_6lA-unsplash.6df49f1f.jpg";